<template>
  <f7-app>
    <f7-view main>
      <f7-page>
        <f7-navbar :title="$appName">
          <f7-subnavbar :inner="false">
            <f7-searchbar
              :custom_search="true"
              v-model:value="searchBarQuery"
              @submit="handleSearch"
            ></f7-searchbar>
          </f7-subnavbar>
        </f7-navbar>
        <f7-row :no-gap="true">
          <f7-col width="66">
            <AppGlobe />
          </f7-col>

          <f7-col width="33">
            <SidebarSidebar :products="products" />
          </f7-col>
        </f7-row>
      </f7-page>
    </f7-view>
  </f7-app>
</template>

<script>
import AppGlobe from "./components/AppGlobe.vue";
import SidebarSidebar from "@/components/Sidebar/Sidebar.vue";

export default {
  name: "App",
  components: { AppGlobe, SidebarSidebar },
  data() {
    return {
      products: [],
      searchBarQuery: ""
    };
  },
  methods: {
    handleSearch() {
      const query = this.searchBarQuery;
      if (query === "") {
        console.log("User entered empty query");
        // this.products remains the same as before
        return;
      }

      // Send search request to Backend API
      fetch(`/api/search/?query=${query}`)
        .then(response => {
          // extract json data from the response
          return response.json();
        })
        .then(data => {
          // set this page's products to the products from the search results
          this.products = data.products;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.handleSearch();
  }
};
</script>
